import HttpClient from "../http/http_client";
export const PostSubscriptionRequest = async (subscriptionDetails) => {
    try {
        
        const response = await HttpClient.post(`subscription/`, subscriptionDetails, {
            headers : {"Content-Type" : "application/json"},
        })
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            };
        }
        return {
            success : false,
            status : null,
            errors : "Something went wrong. Please try again.",
        };
    }
};

export const getSubscriptionRequest = async () => {
    try {
        const response = await HttpClient.get(`subscription/`);
        return {
            success : true, 
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null
            }
        }
    }
};